import { createStore } from 'vuex';
import moduleFileUpload from './modules/fileUpload';
import moduleValidadeAccess from './modules/validadeAccess';

const store = createStore({
  modules: {
    fileUpload: moduleFileUpload,
    validateAccess: moduleValidadeAccess,
  },
});

export default store;
